// extracted by mini-css-extract-plugin
export default {"bold":"SiteCard_bold__4y-c-","description":"SiteCard_description__mwkQT"};